import { render } from "./LoginCompany.vue?vue&type=template&id=19c4b240&scoped=true"
import script from "./LoginCompany.vue?vue&type=script&lang=js"
export * from "./LoginCompany.vue?vue&type=script&lang=js"

import "./LoginCompany.vue?vue&type=style&index=0&id=19c4b240&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c4b240"]])

export default __exports__